module.exports = __webpack_public_path__ + "images/marker-icon.svg";